import {axiParimutuel, GetListOutput, GetListParams} from '@shared/api';
import {validateData} from '@shared/utils';
import {Pool} from '../types';
import {
  PoolResponse,
  responseSchema,
  userPoolsResponseSchema,
} from './backendSchemas';
import {mapPool} from './dataMappers';

export const getPools = async (
  kind: 'user' | 'topic',
  id: string,
  params: GetListParams,
): Promise<GetListOutput<Pool>> => {
  const response = await axiParimutuel.get<PoolResponse>(
    `/admin/${kind === 'user' ? 'users' : 'topics'}/${encodeURIComponent(id)}/pools`,
    {
      params: {page: params.page, per_page: params.pageSize},
    },
  );
  validateData(
    response.data,
    kind === 'user' ? userPoolsResponseSchema : responseSchema,
    `get${kind}Pools`,
  );
  return {
    items: response.data.array.map(pool => mapPool(pool)),
    page: response.data.page,
    pageSize: response.data.per_page,
    total: response.data.total,
    totalPages: response.data.total_pages,
  };
};
